module.exports = __webpack_public_path__ + "img/hot-line.4e9218fc.png";